import BaseAPI from './base'

class ExamStatisticAPI extends BaseAPI {}

export default new ExamStatisticAPI('v1/exam-note', 'ExamNote')
